var m = require('mithril');

module.exports = {
  view: function (vnode) {
    var bg = vnode.attrs.bg || 'bg-red';
    return vnode.attrs.items ? m('div.w-100', {
      class: (vnode.attrs.items.length ? '' : 'dn'),
    }, vnode.attrs.items.map(function (error) {
      return m('div.pa2.mv2.tc.black', {class: bg}, error);
    })) : ''
  }
};
